var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"departments"}},[_c('div',{staticStyle:{"padding":"10px 10px","height":"5%"}},[_c('vxe-grid',_vm._b({ref:"xGrid"},'vxe-grid',_vm.gridOptions,false))],1)])}
var staticRenderFns = []

export { render, staticRenderFns }